import { useEffect, useState } from "react";

const DEFAULT_DELAY = 450;

/**
 * Returns a value that updates only after `delay` ms of the source value being stable.
 * Use for search/filter inputs to avoid excessive API calls.
 */
export function useDebouncedValue<T>(value: T, delay: number = DEFAULT_DELAY): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return debounced;
}
